var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavCapacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    viewBox: "0 0 800 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 30.7,
    height: 153.4,
    x: 105,
    y: 213.7,
    fill: "#062b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153.4,
    height: 30.7,
    x: 278.4,
    y: 526.6,
    fill: "#062b3b",
    transform: "matrix(1,-0.2,0.2,1,-83.1,64.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153.4,
    height: 30.7,
    x: 524.9,
    y: 400.6,
    fill: "#062b3b",
    transform: "matrix(0.8,-0.6,0.6,0.8,-129.8,418.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153.4,
    height: 30.7,
    x: 414.8,
    y: 148.9,
    fill: "#062b3b",
    transform: "matrix(0.6,-0.8,0.8,0.6,51.8,438.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.7,
    height: 153.4,
    x: 432.3,
    y: 309.2,
    fill: "#062b3b",
    transform: "matrix(1,-0.2,0.2,1,-67.1,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.7,
    height: 153.4,
    x: 565.9,
    y: 533,
    fill: "#062b3b",
    transform: "matrix(0.5,-0.9,0.9,0.5,-242.4,786.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 233.3,
    height: 30.7,
    x: 129.6,
    y: 320.1,
    fill: "#062b3b",
    transform: "matrix(0.9,-0.5,0.5,0.9,-127.1,151.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.3,
    cy: 181.3,
    r: 55.5,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.8,
    cy: 101.8,
    r: 42.1,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 678.3,
    cy: 359.4,
    r: 42.1,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.7,
    cy: 556.5,
    r: 49.9,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.3,
    cy: 397.7,
    r: 65.3,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.7,
    cy: 675,
    r: 65.3,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 250,
    r: 93.9,
    fill: "#0097ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.7,
    cy: 503.9,
    r: 99.2,
    fill: "#0097ac"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCapacity);
export default __webpack_public_path__ + "static/media/nav_capacity.f345842ec964a82b4a976067275b144a.svg";
export { ForwardRef as ReactComponent };